import {
  Sheet,
  SheetContent,
  SheetBody,
  SheetHeader,
  SheetTitle,
} from "@repo/ui/components/Base/Sheet";
import { EditUserForm } from "./EditUserForm";
import type { UserWRole } from "@repo/types";
interface EditUserSheetProps {
  open: boolean;
  setOpen: (arg1: boolean) => void;
  user: UserWRole;
  tenantId: string;
}
export const EditUserSheet = ({
  open,
  setOpen,
  user,
  tenantId,
}: EditUserSheetProps) => {
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="overflow-y-scroll">
        <SheetHeader>
          {user && (
            <div>
              <SheetTitle>{`Edit User`}</SheetTitle>
              <SheetBody>
                <EditUserForm
                  user={user}
                  tenantId={tenantId}
                  handleCancel={() => setOpen(false)}
                  handleComplete={() => setOpen(false)}
                />
              </SheetBody>
            </div>
          )}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
